import { ExternalLink } from "lucide-react";
import { t } from "../../i18n";
import {
  isEditableDocument,
  useDocumentEditor,
} from "../document-editor/DocumentEditorContext";

export function ArtifactOpenButton({
  id,
  name,
  url,
}: {
  id: string;
  name: string;
  url: string;
}) {
  const editor = useDocumentEditor();
  const className =
    "rounded-lg p-1.5 text-stone-400 hover:bg-white hover:text-lumen-700 dark:hover:bg-white/10 dark:hover:text-lumen-300";
  if (editor?.enabled && editor.openInWindow && id && isEditableDocument(name))
    return (
      <button
        type="button"
        className={className}
        title="Open in window"
        aria-label={`Open ${name} in editor window`}
        onClick={() => editor.openInWindow?.(id)}
      >
        <ExternalLink size={14} aria-hidden="true" />
      </button>
    );
  return (
    <a
      href={url || undefined}
      target="_blank"
      rel="noreferrer"
      className={className}
      title={t("Open artifact")}
    >
      <ExternalLink size={14} aria-hidden="true" />
    </a>
  );
}
